import React, { useMemo } from 'react';
import styles from '../Chatting/ChatRoom/TripTimeline/TripTimeline.module.css';
import { AiOutlineClose } from 'react-icons/ai';
import KakaoMap from '../../components/KakaoMap/KakaoMap';
import { getDistanceLabel } from '../../utils/formatDistance';

const TripDetailModal = ({ plan, roomName, onClose }) => {
    const schedule = useMemo(() => (Array.isArray(plan?.schedule) ? plan.schedule : []), [plan]);

    const flatPlaces = useMemo(() => {
        return schedule.flatMap((day, dayIdx) => {
            const places = Array.isArray(day?.places) ? day.places : [];
            return places.map((place, idx) => ({
                ...place,
                day: day?.day ?? (dayIdx + 1),
                order: idx + 1,
            }));
        });
    }, [schedule]);

    return (
        <div className={styles.overlay}>
            <div className={styles.content}>
                <button className={styles.closeBtn} onClick={onClose}>
                    <AiOutlineClose />
                </button>

                <div className={styles.scrollArea}>
                    <h2 className={styles.headerTitle}>{roomName || '여행 일정 전체보기'}</h2>
                    {plan?.title && (
                        <div className={styles.planTitle}>
                            {plan.title}
                        </div>
                    )}

                    <div className={styles.mapSection}>
                        <div className={styles.mapHeader}>
                            <span className={styles.mapTitle}>여행 루트 지도</span>
                            <span className={styles.mapSubtitle}>{flatPlaces.length}곳 표시</span>
                        </div>
                        <div className={styles.mapBox}>
                            <KakaoMap places={flatPlaces} />
                        </div>
                    </div>

                    {schedule.length === 0 && (
                        <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                            저장된 일정이 없습니다.
                        </div>
                    )}

                    {schedule.map((dayItem, dayIdx) => (
                        <div key={dayIdx}>
                            <div className={styles.dayHeader}>
                                <div>
                                    <span className={styles.dayTitle}>day {dayItem?.day ?? (dayIdx + 1)}</span>
                                    <span className={styles.dayDate}>{dayItem.date}</span>
                                </div>
                            </div>

                            <div className={styles.timelineContainer}>
                                {dayItem.places && dayItem.places.length > 0 && <div className={styles.timelineLine}></div>}

                                {dayItem.places && dayItem.places.map((place, placeIdx) => {
                                    const nextPlace = dayItem.places[placeIdx + 1];
                                    const distanceLabel = placeIdx < dayItem.places.length - 1
                                        ? getDistanceLabel(place, nextPlace)
                                        : '';
                                    const showDistance = Boolean(distanceLabel);

                                    return (
                                        <React.Fragment key={placeIdx}>
                                            <div className={styles.timelineItem}>
                                                <div className={styles.timelineLeft}>
                                                    <div className={styles.circle}>{placeIdx + 1}</div>
                                                    {showDistance && (
                                                        <div className={styles.distanceBadge}>{distanceLabel}</div>
                                                    )}
                                                </div>

                                                <div className={styles.placeCard}>
                                                    <div style={{ flex: 1 }}>
                                                        <div className={styles.placeName}>{place.name}</div>
                                                        <div className={styles.placeDesc}>{place.category || place.address || '장소'}</div>
                                                        {place.address && <div style={{ fontSize: '12px', color: '#aaa' }}>{place.address}</div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TripDetailModal;
